import { FiFile } from "react-icons/fi";
import { FaFilePdf, FaImage, FaRegTimesCircle } from "react-icons/fa";

export const handleDrop = (event, setFiles) => {
  event.preventDefault();
  const newFiles = Array.from(event.dataTransfer.files);
  setFiles((prevFiles) => [...prevFiles, ...newFiles]);
};

export const handleFileInput = (event, setFiles) => {
  const newFiles = Array.from(event.target.files);
  setFiles((prevFiles) => [...prevFiles, ...newFiles]);
};

export const handleRemoveFile = (index, setFiles) => {
  setFiles((prevFiles) => prevFiles.filter((file, i) => i !== index));
};

export const getFileIcon = (fileType) => {
  // if (fileType.startsWith("image/")) {
  //   return <FaImage size={20} />;
  // } else if (fileType === "application/pdf") {
  //   return <FaFilePdf size={20} color="#F40F02" />;
  // } else {
  //   return <FiFile size={20} color="#F40F02" />;
  // }
  return <FaFilePdf size={32} color="#F40F02" />;
};

export const fileCLaimsExist = [
  "97001",
  "97003",
  // "97012",
  "97035",
  "97001",
  "20520",
];

export const getActiveRoute = (routes) => {
  let activeRoute = "";
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].collapse) {
      let collapseActiveRoute = getActiveRoute(routes[i].items);
      if (collapseActiveRoute !== activeRoute) {
        return collapseActiveRoute;
      }
    } else if (routes[i].category) {
      let categoryActiveRoute = getActiveRoute(routes[i].items);
      if (categoryActiveRoute !== activeRoute) {
        return categoryActiveRoute;
      }
    } else {
      if (window.location.href.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
  }
  return activeRoute;
};
export const getActiveNavbar = (routes) => {
  let activeNavbar = false;
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].collapse) {
      let collapseActiveNavbar = getActiveNavbar(routes[i].items);
      if (collapseActiveNavbar !== activeNavbar) {
        return collapseActiveNavbar;
      }
    } else if (routes[i].category) {
      let categoryActiveNavbar = getActiveNavbar(routes[i].items);
      if (categoryActiveNavbar !== activeNavbar) {
        return categoryActiveNavbar;
      }
    } else {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
  }
  return activeNavbar;
};
export const getActiveNavbarText = (routes) => {
  let activeNavbar = false;
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].collapse) {
      let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
      if (collapseActiveNavbar !== activeNavbar) {
        return collapseActiveNavbar;
      }
    } else if (routes[i].category) {
      let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
      if (categoryActiveNavbar !== activeNavbar) {
        return categoryActiveNavbar;
      }
    } else {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].messageNavbar;
      }
    }
  }
  return activeNavbar;
};
